import React from "react";
import { Redirect, Route } from "react-router";
import useViewer from "../hooks/useViewer";

import { Layout } from "../components/wombat-ui";
import useTokenLogin from "../hooks/useTokenLogin";

function PrivateRoute({ component: Component, ...restProps }) {
  const viewer = useViewer();

  const { checked } = useTokenLogin();

  if (!checked) {
    return null;
  }

  return (
    <>
      <Route
        {...restProps}
        render={(props) => {
          return viewer ? (
            <>
              <Layout>
                <Component {...props} />
              </Layout>
            </>
          ) : (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          );
        }}
      />
    </>
  );
}

export default PrivateRoute;
